import Constants from 'expo-constants'
import { Dimensions, StatusBar } from 'react-native'

const styles = {
    // Posts
    views: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 10,
        with: '100%',
        height: 2,
    },
    descriptionPost: {
        marginTop: 4,
        paddingHorizontal: 10,
    },
}

export default styles
